import { useConfigProperty } from '@leagueplatform/core';
import { GET_WIDGET_DATA } from '@leagueplatform/masonry-api';
import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { useQuery } from 'react-query';

const getJourneyRewardsProgram = (widget_id: string) =>
  SocketAsFetch.fetch({
    message_type: GET_WIDGET_DATA,
    info: {
      widget_id,
      version: 0,
    },
  });

const rewardsWidgetIdMap: Record<string, string> = {
  'highmark-iel-web': 'highmark_iel_rewards_programs',
  'highmark-beneficity-web': 'highmark_beneficity_rewards_programs',
  'highmark-amh-web': 'highmark_allmyhealth_rewards_programs',
};

const REWARDS_PROGRAM_QUERY_KEY = 'JOURNEY_REWARDS_PROGRAM';

export const useGetJourneyRewardsProgram = () => {
  const clientId = useConfigProperty('core.clientId');
  const hasRewardsWidgetId = Object.keys(rewardsWidgetIdMap).includes(clientId);
  const widgetId = hasRewardsWidgetId ? rewardsWidgetIdMap[clientId] : '';

  return useQuery({
    queryKey: [REWARDS_PROGRAM_QUERY_KEY],
    queryFn: () => getJourneyRewardsProgram(widgetId),
    enabled: hasRewardsWidgetId,
  });
};
